
    import '/home/ec2-user/Youlify-Design/docs/spec/research-empty.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/home/ec2-user/Youlify-Design/docs/spec/research-empty.zh-CN.md?type=demo')
};